import styled from "@emotion/styled";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Layout from "components/structure/Layout";
import React, { useEffect, useState } from "react";
import { Button, CircularProgress, Grid, IconButton, InputAdornment } from "@mui/material";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { AuthData } from "auth/AuthWarpper";
import DataTable from "utils/DataTable/DataTable";
import NoData from "assets/noData.svg";
import PaginationImport from "../Common/PaginationImport";
import ViewButton from "utils/ViewButton";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import ImportHierarchyService from "services/ImportHierarchyService";
import ClearIcon from "@mui/icons-material/Clear";
import labels from "utils/lables.json"
import ImportService from "services/ImportService";
import { convertToLocalTime } from "utils/CommonFunction";
import CustomPagination from "../Common/CustomPagination";


const columns = [
  {
    field: "levelCode",
    headerName: "Level Code",
    flex: 1,
    headerAlign: "left",
    align: "left",
    renderCell: (params) => (
      <span style={{ padding: "20px" }}>{params.value}</span>
    ),
  },
  {
    field: "locationName",
    headerName: "Location Name",
    flex: 1,
    headerAlign: "left",
    align: "left",
  },
  {
    field: "parentLocationCode",
    headerName: "Parent Location Code",
    flex: 1,
    headerAlign: "left",
    align: "left",
  },
  {
    field: "personName",
    headerName: "Person Name",
    flex: 1,
    headerAlign: "left",
    align: "left",
  },
  {
    field: "batOneId",
    headerName: "BAT One ID",
    flex: 1,
    headerAlign: "left",
    align: "left",
  },
  {
    field: "cropYear",
    headerName: "Crop Year",
    flex: 1,
    headerAlign: "left",
    align: "left",
    renderCell: (params) =>
      params.row.cropYear ?? params.row.cropYearName ?? params.row.cyCropYear ?? "",
  },
  {
    field: "status",
    headerName: "Status",
    flex: 1,
    headerAlign: "left",
    align: "left",
    renderCell: (params) => (
      <span style={{ color: params.value === "Fail" ? "red" : "green" }}>
        {params.value}
      </span>
    ),
  },
  {
    field: "operation",
    headerName: "Operation",
    flex: 1,
    headerAlign: "left",
    align: "left",
  },
  {
    field: "errorDescription",
    headerName: "Error Description",
    flex: 1,
    headerAlign: "left",
    align: "left",
  },
  {
    field: "actions",
    type: "actions",
    headerName: "View Details",
    width: 250,
    headerAlign: "left",
    align: "left",
    getActions: (params) => {
      const state = {
        id: params.id,
        levelCode: params.row.levelCode,
        locationName: params.row.locationName,
        parentLocationCode: params.row.parentLocationCode,
        personName: params.row.personName,
        batOneId: params.row.batOneId,
        status: params.row.status,
        operation: params.row.operation,
        errorDescription: params.row.errorDescription,
        locationCode: params.row.locationCode,
        legacyCode: params.row.legacyCode,
        cropYear: params.row.cropYear ?? params.row.cropYearName ?? params.row.cyCropYear,
      };
      const url = `/viewHierarchyDetails/${params.id}`;
      return [<ViewButton state={state} url={url} />];
    },
  },
];

const ViewLogHierarchy = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = AuthData();
  const params = useParams();
  const { id } = params;
  const dataPrev = location.state;

  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(20);
  const [totalItems, setTotalItems] = useState(5);
  const [data, setData] = useState([]);
  const [value, setValue] = useState("");

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  const paginate = (pageNumber, itemsPerPage) => {
    callHierarchyAPI(pageNumber - 1, itemsPerPage);
  };

  useEffect(() => {
    callHierarchyAPI(currentPage, itemsPerPage);
  }, [currentPage, itemsPerPage, value]);

  const callHierarchyAPI = (pNumber, size) => {
    setLoading(true);
    const query = {
      id: id,
      pageNumber: pNumber,
      size: size,
      status: value ? value == "All" ? "" : value : undefined,
    };

    ImportHierarchyService.FetchAllHierarchyViewLog(query)
      .then((res) => {
        setCurrentPage(pNumber);
        setItemsPerPage(size);
        setData(res?.data?.response?.importHierarchyLog);
        setTotalItems(res?.data?.response?.totalItems);
      })
      .catch((error) => {
        setData([])
        console.error("API call failed:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleExportAll = async () => {
    try {
      const response = await ImportService.ExportAll({ ilHeaderId: id }, {
        responseType: 'text' // Expecting the response as plain text (CSV content)
      });

      if (response.status !== 200) {
        throw new Error('Network response was not ok');
      }
      const BOM = '\uFEFF'; // UTF-8 BOM
      const fileContent = BOM + response.data;
      // Create a Blob from the text content
      
      const blob = new Blob([fileContent], { type: 'text/csv;charset=utf-8;' }); // Ensure MIME type is 'text/csv'
      // Create a URL for the Blob and trigger a download
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'data.csv'; // Set the file name for download
      document.body.appendChild(a); // Append the anchor to the document
      a.click(); // Trigger the download
      document.body.removeChild(a); // Remove the anchor from the document
      window.URL.revokeObjectURL(url); // Clean up the object URL
    } catch (error) {
      console.error('Error downloading file:', error);
      // Handle the error (e.g., show a message to the user)
    }
  };

  return (
    <Layout title={labels.pageTitle}>
      <div style={{ paddingBottom: "4rem" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: 2,
          }}
        >
          <Heading>
            Import Hierarchy
          </Heading>
          <Button
            sx={{
              borderRadius: 100,
              minWidth: 95,
              minHeight: 44,
              background: "#102A62",
            }}
            variant="contained"
            startIcon={<KeyboardBackspaceIcon />}
            onClick={() => navigate(-1)}
          >
            {labels.backButton}
          </Button>
        </Box>
        <PaperContainer>
          <form autoComplete="off">
            <Grid container spacing={2}>
              <Grid
                item
                md={4}
                xs={12}
                sx={{
                  display: { md: "flex", sx: "block" },
                  alignItems: "center",
                }}
              >
                <InputLabel sx={{ width: "10rem" }} htmlFor="my-input">
                  {labels.fileNameLabel}
                </InputLabel>
                <Box>
                  <TextField
                    sx={{ width: { xs: "100%", md: "14rem" } }}
                    id="profileCode"
                    aria-describedby="my-helper-text"
                    label={""}
                    value={
                      dataPrev?.fileName === null ? "null" : dataPrev?.fileName
                    }
                    name="profileCode"
                    onChange={handleChange}
                    disabled={true}
                  />
                </Box>
              </Grid>
              <Grid
                item
                md={4}
                xs={12}
                sx={{
                  display: { md: "flex", xs: "block" },
                  alignItems: "center",
                }}
              >
                <InputLabel sx={{ width: "10rem" }} htmlFor="my-input">
                  {labels.uploadedByLabel}
                </InputLabel>
                <Box>
                  <TextField
                    sx={{ width: { xs: "100%", md: "14rem" } }}
                    id="profileCode"
                    aria-describedby="my-helper-text"
                    label={""}
                    value={
                      dataPrev.uploadedBy === null
                        ? "null"
                        : dataPrev.uploadedBy
                    }
                    name="profileCode"
                    onChange={handleChange}
                    disabled={true}
                  />
                </Box>
              </Grid>
              <Grid
                item
                md={4}
                xs={12}
                sx={{
                  display: { md: "flex", xs: "none" },
                  alignItems: "center",
                  flexDirection: "end",
                }}
              >
                <InputLabel sx={{ width: "10rem" }} htmlFor="my-input">
                  {labels.uploadStatusLabel}
                </InputLabel>
                <Box>
                  <TextField
                    sx={{ width: { xs: "100%", md: "14rem" } }}
                    id="profileCode"
                    aria-describedby="my-helper-text"
                    label={""}
                    value={
                      dataPrev.uploadStatus === null
                        ? "null"
                        : dataPrev.uploadStatus
                    }
                    name="profileCode"
                    onChange={handleChange}
                    disabled={true}
                  />
                </Box>
              </Grid>
              <Grid
                item
                md={4}
                xs={12}
                sx={{
                  display: { md: "flex", sx: "block" },
                  alignItems: "center",
                }}
              >
                <InputLabel sx={{ width: "10rem" }} htmlFor="my-input">
                  {labels.commentsLabel}
                </InputLabel>
                <Box>
                  <TextField
                    sx={{ width: { xs: "100%", md: "14rem" } }}
                    id="my-input"
                    aria-describedby="my-helper-text"
                    label={""}
                    value={
                      dataPrev.comments === null ? "null" : dataPrev.comments
                    }
                    name="profileName"
                    onChange={handleChange}
                    disabled={true}
                  />
                </Box>
              </Grid>
              <Grid
                item
                md={4}
                xs={12}
                sx={{
                  display: { md: "flex", sx: "block" },
                  alignItems: "center",
                }}
              >
                <InputLabel sx={{ width: "10rem" }} htmlFor="my-input">
                  {labels.timestampLabel}
                </InputLabel>
                <Box>
                  <TextField
                    sx={{ width: { xs: "100%", md: "14rem" } }}
                    id="my-input"
                    aria-describedby="my-helper-text"
                    label={""}
                    value={
                      dataPrev.timestamp === null ? "null" : dataPrev.timestamp
                    }
                    name="profileName"
                    onChange={handleChange}
                    disabled={true}
                  />
                </Box>
              </Grid>
              <Grid
                item
                md={4}
                xs={12}
                sx={{
                  display: { md: "flex", xs: "flex" },
                  alignItems: "center",
                  flexDirection: "end",
                }}
              >
                <InputLabel sx={{ width: "10rem" }} htmlFor="my-input">
                  {labels.successFailLabel}
                </InputLabel>
                <Box>
                  <TextField
                    sx={{ width: { xs: "100%", md: "14rem" } }}
                    id="my-input"
                    aria-describedby="my-helper-text"
                    label={""}
                    value={dataPrev.success + "/" + dataPrev.fail}
                    name="profileName"
                    onChange={handleChange}
                    disabled={true}
                  />
                </Box>
              </Grid>
            </Grid>
          </form>
        </PaperContainer>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mt: 1,
          }}
        >
          <Box>
            <FormControl
              sx={{ m: 1, minWidth: { xs: 150, md: 300 }, minHeight: 50 }}
            >
              <TextField
                select
                value={value}
                onChange={handleChange}
                displayEmpty
                inputProps={{ "aria-label": "Without label" }}
                label={value ? "" : "Status"}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <div
                        edge="end"
                        onClick={() => setValue("")}
                        sx={{ visibility: value !== "" ? "visible" : "hidden" }}
                      >
                        <ClearIcon sx={{ mt: 0.5, mr: 2, cursor: "pointer", visibility: value !== "" ? "visible" : "hidden" }} />
                      </div>
                    </InputAdornment>
                  ),
                }}

              >
                <MenuItem value="All">
                  All
                </MenuItem>
                <MenuItem value="Success">{labels.successOption}</MenuItem>
                <MenuItem value="Fail">{labels.failOption}</MenuItem>
              </TextField>
            </FormControl>
          </Box>
          <Box>
            <Button
              sx={{
                borderRadius: 2,
                minWidth: 156,
                minHeight: 44,
                background: "#EF7D00",
                marginTop: { xs: 1 },
                marginLeft: { xs: 1 },
                "&:hover": {
                  background: "#EF7D00",
                },
              }}
              startIcon={loading && <CircularProgress size={20} />}
              variant="contained"
              onClick={() => handleExportAll()}
              disabled={loading}
            >
              {labels.exportButton}
            </Button>
          </Box>
        </Box>
        <Box>
          {data.length !== 0 ? (
            <>
              <DataTable
                getRowId={(row) => row.ihLogId}
                data={data}
                rows={data}
                columns={columns}
                hideFooter={true}
              />
            </>
          ) : (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <img src={NoData} style={{ height: "100px" }} alt="No Data" />
              <p>{labels.noDataMessage}</p>
            </Box>
          )}
        </Box>
      </div>
      {data.length !== 0 ?
      <Box>
        <div style={{ position: "absolute", width: "96%", bottom: "70px" }}>
        <CustomPagination
                itemsPerPage={itemsPerPage}
                setItemsPerPage={(v) => setItemsPerPage(v)}
                totalItems={totalItems}
                paginate={paginate}
                currentPage={currentPage}
              />
        </div>
      </Box>:""}
    </Layout>
  );
};

const Heading = styled.div`
  color: rgba(115, 125, 134, 1);
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
`;

const PaperContainer = styled(Paper)`
  padding: 2rem 1rem;
`;

export default ViewLogHierarchy;
